import moment from 'moment';
import { ACTION_TYPES } from '@/actions';

const INIT_STATE = {
  prodInfo: {},
  stockPriceInfo: {},
  selectedInfo: {},
  calendarInfo: {
    monthText: '',
    dayList: []
  },
  // 商品适用优惠券
  couponList: []
};

/**
 * 处理库价信息 (将Array格式转化成Object格式)
 * @param {Array} stockPriceList 接口返回的库价列表
 */
function processStockPriceInfo(stockPriceList) {
  const stockPriceInfo = {};
  stockPriceList?.forEach(({ stockDay, ...rest }) => {
    stockPriceInfo[stockDay] = { stockDay, ...rest };
  });
  return stockPriceInfo;
}

function getCalendarDayList(monthText, stockPriceInfo, prodInfo) {
  // 计算提前停售天数
  let advanceDay = 0;
  const { configDto } = prodInfo;
  if (configDto.configValue === 2) {
    advanceDay = configDto.configDay || 0;
    // const { configDay = 0, configHour = 0, configMinutes = 0 } = configDto;
    // const canSaleDate = moment().add(configDay, 'd').add(configHour, 'h').add(configMinutes, 'm');
    // advanceDay = canSaleDate.diff(moment(), 'days') + 1;
  }

  // 当月第一天
  const startDayText = `${monthText}-01`;
  // 当月第一天是星期几
  const startDayWeek = moment(startDayText).day();
  // 当月最后一天
  let endDay = moment(startDayText).endOf('month');
  // 展示的第一天
  let showFirstDay = moment(startDayText);
  if (startDayWeek !== 7) {
    showFirstDay = moment(startDayText).subtract(startDayWeek, 'days');
  }
  const diffDays = endDay.diff(showFirstDay, 'days') + 1;
  const showWeeks = Math.ceil(diffDays / 7);
  const dayList = [];
  for (let i = 0; i < showWeeks; i += 1) {
    let weekList = [];
    for (let j = 0; j < 7; j += 1) {
      const showDay = moment(showFirstDay).add((7 * i + j), 'days');
      const stockPrice = stockPriceInfo[moment(showDay).format('YYYY-MM-DD')];
      const disabled = showDay.isBefore(moment().add(advanceDay, 'days'), 'day');
      weekList.push({
        // 当前月份的日期才展示
        visible: showDay.isSame(moment(startDayText), 'month'),
        // 当前日期前的指定天数不可点击
        disabled,
        day: moment(showDay).format('YYYY-MM-DD'),
        date: moment(showDay).date(),
        stockNum: stockPrice ? stockPrice.stockNum : null,
        salePrice: stockPrice && stockPrice.salePrice
      });
    }
    dayList.push(weekList);
  }
  return dayList;
}

/**
 * 更新商品适用优惠券信息
 * @param {Array} prevList 原来优惠券列表
 * @param {Array} updateList 需要修改的优惠券列表
 */
function updateCouponList(prevList, updateList) {
  console.log('updateCouponList', prevList, updateList)
  const newCouponList = prevList && prevList.map((item) => {
    const findInRes = updateList.find((resItem) => { return resItem.id === item.id; });
    if (findInRes) {
      return {
        ...item,
        pickStatus: findInRes.pickStatus
      }
    }
    return item;
  });
  console.log('新的优惠券状态', newCouponList);
  return newCouponList;
}

export default function prodDetail(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 清除商品详情信息
    case ACTION_TYPES.SUBMIT_ORDER_CONFIRM:
    case ACTION_TYPES.CLEAR_PROD_DETAIL_INFO:
      result = INIT_STATE;
      break;
    // 获取产品详情
    case ACTION_TYPES.GET_PROD_DETAIL:
      result.prodInfo = payload;
      break;
    // 设置展示的日历
    case ACTION_TYPES.SET_CALENDAR_MONTH_TEXT:
      result.calendarInfo.monthText = payload;
      break;
    // 获取产品库价信息
    case ACTION_TYPES.GET_PROD_STOCK_PRICE:
      const { prodInfo, calendarInfo } = result;
      console.log(result,'resultresultresultresult')
      const stockPriceInfo = processStockPriceInfo(payload);
      result.stockPriceInfo = stockPriceInfo;
      result.calendarInfo.dayList = getCalendarDayList(calendarInfo.monthText, stockPriceInfo, prodInfo);
      break;
    // 更新选中套餐信息
    case ACTION_TYPES.UPDATE_SELECTED_INFO:
      result.selectedInfo = payload;
      break;
    // 获取商品优惠券
    case ACTION_TYPES.GET_COUPON_LIST_BY_SPU_NO:
      result.couponList = payload;
      break;
    // 领取商品适用优惠券
    case ACTION_TYPES.PICK_COUPON_BY_SPU_NO:
      result.couponList = updateCouponList(result.couponList, payload.resList);
      break;
    default:
      result = state;
  }
  return result;
}
